import { QBadge as e, QBtn as t, QChip as n, QDrawer as r, QExpansionItem as i, QFooter as a, QHeader as o, QIcon as s, QItem as c, QItemLabel as l, QItemSection as u, QLayout as d, QLinearProgress as f, QList as p, QMenu as m, QPage as h, QPageContainer as g, QPagination as _, QTooltip as v, debounce as y, useQuasar as ee } from "quasar";
import { Fragment as b, computed as x, createBlock as S, createCommentVNode as C, createElementBlock as w, createElementVNode as T, createSlots as E, createTextVNode as D, createVNode as O, defineComponent as k, mergeProps as A, normalizeClass as j, normalizeStyle as M, onMounted as N, openBlock as P, provide as F, ref as I, renderList as L, renderSlot as R, resolveComponent as z, resolveDynamicComponent as B, toDisplayString as V, unref as H, useSlots as U, watch as W, withCtx as G } from "vue";
import { useI18n as K } from "vue-i18n";
import { RouterView as q, useRouter as J } from "vue-router";
import { defineStore as te } from "pinia";
import { DEFAULT_SIDEBAR_NAV_WIDTH as ne, quasarLocales as re, useGlobalStore as Y, useUserStore as ie } from "@editor/ui-utils";
//#region src/constants/index.ts
var ae = 98, X = 125, Z = 300, oe = {
	width: 300,
	miniWidth: 125,
	isDrawerOpenInitValue: !0
}, Q = k({
	components: { QIcon: s },
	props: {
		value: {
			type: String,
			required: !1,
			default: ""
		},
		size: {
			type: String,
			required: !1,
			default: "24"
		}
	},
	computed: { iconClass() {
		return this.value === "check-circle" || this.value === "download" ? "green--text text--darken-1" : this.value === "clock" ? "blue--text text--darken-3" : ["minus-circle", "x-circle"].includes(this.value) ? "red--text" : this.value === "alert-circle" ? "orange--text" : "grey--text text--darken-1";
	} }
}), $ = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
};
//#endregion
//#region src/components/status-icon.vue
function se(e, t, n, r, i, a) {
	return P(), S(s, {
		class: j(["d-flex align-self-center", e.iconClass]),
		size: e.size,
		name: e.value
	}, null, 8, [
		"class",
		"size",
		"name"
	]);
}
var ce = /* @__PURE__ */ $(Q, [["render", se]]), le = {
	isLeftDrawerOpen: !0,
	isRightDrawerOpen: !0
}, ue = te("layout", {
	state() {
		return { layouts: {} };
	},
	actions: {
		getLayout(e) {
			if (e) return this.layouts[e];
		},
		setLayout(e, t) {
			if (!t) return;
			let n = this.layouts[t] || {};
			this.layouts[t] = {
				...le,
				...n,
				...e
			};
		},
		resetLayout(e) {
			e && (this.layouts[e] = le);
		},
		removeLayout(e) {
			delete this.layouts[e];
		},
		removeAllLayouts() {
			this.layouts = {};
		}
	},
	persist: !0
}), de = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "layout-drawer",
	props: {
		side: { default: "left" },
		behaviour: { default: "desktop" },
		width: { default: void 0 },
		miniWidth: { default: void 0 },
		isDrawerOpenInitValue: {
			type: Boolean,
			default: !0
		},
		layoutId: { default: void 0 }
	},
	setup(e) {
		let n = e, i = ue(), a = I(n.isDrawerOpenInitValue);
		F("isDrawerOpen", a);
		let o = x(() => ({
			left: a.value ? "chevrons-left" : "chevrons-right",
			right: a.value ? "chevrons-right" : "chevrons-left"
		})[n.side]);
		return W(a, (e) => {
			switch (n.side) {
				case "left":
					i.setLayout({ isLeftDrawerOpen: e }, n.layoutId);
					break;
				case "right":
					i.setLayout({ isRightDrawerOpen: e }, n.layoutId);
					break;
			}
		}), W(() => n.layoutId, (e) => {
			if (!e) return;
			let t = i.getLayout(e);
			a.value = {
				left: t?.isLeftDrawerOpen,
				right: t?.isRightDrawerOpen
			}[n.side] ?? n.isDrawerOpenInitValue;
		}, { immediate: !0 }), (n, i) => n.$slots["drawer-content"] ? (P(), S(H(r), {
			key: 0,
			"model-value": !0,
			"show-if-above": "",
			side: e.side,
			mini: !a.value,
			width: e.width,
			"mini-width": e.miniWidth,
			behavior: e.behaviour,
			bordered: ""
		}, {
			default: G(() => [R(n.$slots, "drawer-content", {}, void 0, !0), T("div", { class: j(["row drawer-footer", e.side === "left" ? "justify-end" : "justify-start"]) }, [O(H(t), {
				color: "primary",
				flat: "",
				onClick: i[0] ||= (e) => a.value = !a.value
			}, {
				default: G(() => [O(H(s), {
					size: "24px",
					name: o.value
				}, null, 8, ["name"])]),
				_: 1
			})], 2)]),
			_: 3
		}, 8, [
			"side",
			"mini",
			"width",
			"mini-width",
			"behavior"
		])) : C("", !0);
	}
}), [["__scopeId", "data-v-c48fb062"]]), fe = Y(), pe = x(() => ({
	width: `calc(100vw - ${fe.sidebarNavigationWidth}px)`,
	height: "100vh",
	top: "0",
	left: `${fe.sidebarNavigationWidth}px`,
	transition: "left 0.2s"
})), me = x(() => ({
	width: "calc(100vw - 48px)",
	height: "calc(100vh - 48px)"
})), he = { class: "row flex-center" }, ge = {
	key: 1,
	class: "text-right q-ml-md"
}, _e = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "edit-view.layout",
	props: {
		backRoute: { default: void 0 },
		backButtonLabel: { default: void 0 },
		backButtonOffset: {
			type: Boolean,
			default: !0
		},
		id: { default: void 0 },
		hasLayoutContentPadding: {
			type: Boolean,
			default: !0
		},
		dialog: {
			type: Boolean,
			default: !1
		},
		leftDrawerProps: { default: void 0 },
		rightDrawerProps: { default: void 0 }
	},
	emits: [
		"back:clicked",
		"back:modal",
		"close"
	],
	setup(e, { emit: n }) {
		let { t: r } = K(), i = J(), c = e, l = n, u = () => {
			c.backRoute && c.dialog && l("back:modal"), window.history.length > 1 && !c.backRoute ? (i.go(-1), l("back:clicked")) : (i.push(c.backRoute || "/"), l("back:clicked"));
		};
		return (n, i) => (P(), S(H(d), {
			view: "hhh LpR fFf",
			class: "bg-white",
			container: "",
			style: M(e.dialog ? H(me) : H(pe))
		}, {
			default: G(() => [
				O(H(o), {
					class: "layout-header q-pt-none q-pb-none q-pl-md q-pr-md row",
					"height-hint": H(98)
				}, {
					default: G(() => [R(n.$slots, "layout-header", {}, void 0, !0), T("div", he, [
						R(n.$slots, "layout-header-right", {}, void 0, !0),
						e.backRoute ? (P(), S(H(t), {
							key: 0,
							"data-qa-back-button": "",
							link: "",
							outline: "",
							class: j(["custom-back-button q-ml-md", { "q-ml-auto": e.backButtonOffset }]),
							color: "white",
							"text-color": "black",
							small: "",
							onClick: u
						}, {
							default: G(() => [O(H(s), {
								color: "primary",
								name: "chevron_left"
							}), T("span", null, V(e.backButtonLabel || H(r)("common.back")), 1)]),
							_: 1
						}, 8, ["class"])) : C("", !0),
						e.dialog ? (P(), w("div", ge, [O(H(t), {
							"data-qa-close-modal-button": "",
							icon: "close",
							flat: "",
							round: "",
							onClick: i[0] ||= (e) => l("close")
						})])) : C("", !0)
					])]),
					_: 3
				}, 8, ["height-hint"]),
				O(de, A({ side: "left" }, e.leftDrawerProps, { "layout-id": e.id }), E({ _: 2 }, [n.$slots["layout-left-drawer"] ? {
					name: "drawer-content",
					fn: G(() => [R(n.$slots, "layout-left-drawer", {}, void 0, !0)]),
					key: "0"
				} : void 0]), 1040, ["layout-id"]),
				O(de, A({ side: "right" }, e.rightDrawerProps, { "layout-id": e.id }), E({ _: 2 }, [n.$slots["layout-right-drawer"] ? {
					name: "drawer-content",
					fn: G(() => [R(n.$slots, "layout-right-drawer", {}, void 0, !0)]),
					key: "0"
				} : void 0]), 1040, ["layout-id"]),
				O(H(g), null, {
					default: G(() => [O(H(h), {
						class: "layout-content",
						padding: e.hasLayoutContentPadding
					}, {
						default: G(() => [R(n.$slots, "layout-content", {}, void 0, !0)]),
						_: 3
					}, 8, ["padding"])]),
					_: 3
				}),
				n.$slots["layout-footer"] ? (P(), S(H(a), {
					key: 0,
					class: "layout-footer q-layout-padding row"
				}, {
					default: G(() => [R(n.$slots, "layout-footer", {}, void 0, !0)]),
					_: 3
				})) : C("", !0)
			]),
			_: 3
		}, 8, ["style"]));
	}
}), [["__scopeId", "data-v-07ce3c3a"]]), ve = 6, ye = /* @__PURE__ */ k({
	__name: "list-pagination",
	props: { pagination: {} },
	setup(e) {
		let t = e, n = x({
			get() {
				return t.pagination?.currentPage ?? 1;
			},
			set(e) {
				t.pagination?.goToPage(e);
			}
		}), r = x(() => {
			let e = t.pagination?.currentPage ?? 1, n = t.pagination?.nextPageLink;
			return e + (n && Number(new URL(n).searchParams.get("page")) > e ? 1 : 0);
		}), i = x(() => r.value >= ve ? ve : r.value);
		return (t, a) => (P(), S(H(_), {
			modelValue: n.value,
			"onUpdate:modelValue": a[0] ||= (e) => n.value = e,
			max: r.value,
			"max-pages": i.value,
			disable: e.pagination?.loading,
			"direction-links": "",
			"icon-prev": "fast_rewind",
			"icon-next": "fast_forward",
			"active-color": "primary"
		}, null, 8, [
			"modelValue",
			"max",
			"max-pages",
			"disable"
		]));
	}
}), be = { class: "row" }, xe = {
	key: 0,
	class: "col-grow q-py-sm"
}, Se = { class: "row" }, Ce = {
	key: 0,
	class: "col-md-12"
}, we = {
	key: 2,
	class: "col-grow flex justify-end self-center q-mr-sm"
}, Te = { class: "row" }, Ee = { key: 0 }, De = {
	key: 1,
	class: "q-pt-sm"
}, Oe = { style: { position: "relative" } }, ke = { class: "row overflow-y-auto w-full mx-0" }, Ae = { style: { width: "100%" } }, je = { class: "row justify-end q-pa-sm" }, Me = { class: "q-pa-md" }, Ne = {
	key: 0,
	class: "list-footer row"
}, Pe = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "list-view.layout",
	props: {
		selectedFilterCount: { default: 0 },
		multi: { type: Boolean },
		multiLabel: { default: "" },
		newButtonLabel: { default: "" },
		newButtonClass: { default: "col-auto q-pa-sm" },
		newRoute: { default: "" },
		showNewButton: {
			type: Boolean,
			default: !0
		},
		pagination: { default: void 0 },
		dialog: {
			type: Boolean,
			default: !1
		},
		hideClose: {
			type: Boolean,
			default: !1
		},
		hideFooter: {
			type: Boolean,
			default: !1
		},
		shouldRemoveScrollElement: {
			type: Boolean,
			default: !0
		}
	},
	emits: [
		"clear-filters",
		"close",
		"new-btn:clicked",
		"save-multi-selection",
		"back:modal"
	],
	setup(n, { emit: i }) {
		let c = n, l = i, { t: u } = K(), p = I(!1), m = U(), _ = x(() => c.hideFooter ? !1 : c.pagination?.nextPageLink || c.pagination?.previousPageLink || c.multi ? !0 : !!m.footer), v = () => {
			let e = document.getElementsByClassName("q-table__middle")[0];
			e && e.classList.remove("scroll");
		};
		return N(() => c.shouldRemoveScrollElement && v()), (i, c) => (P(), S(H(d), {
			view: "hHh lpR fFf",
			class: "bg-white",
			container: "",
			style: M(n.dialog ? H(me) : H(pe))
		}, {
			default: G(() => [
				(P(), S(B(n.dialog || p.value ? H(o) : "header"), {
					bordered: "",
					class: "text-black bg-white q-py-sm q-px-md"
				}, {
					default: G(() => [n.dialog ? (P(), w("div", {
						key: 0,
						class: j(["text-right", { hidden: n.hideClose }])
					}, [O(H(t), {
						"data-qa-close-modal-button": "",
						icon: "close",
						flat: "",
						round: "",
						onClick: c[0] ||= (e) => l("close")
					})], 2)) : C("", !0), R(i.$slots, "all-filters", { areExtraFiltersVisible: p.value }, () => [
						T("div", be, [i.$slots["main-filters"] ? (P(), w("div", xe, [R(i.$slots, "main-filters", {}, void 0, !0)])) : C("", !0), i.$slots["new-button"] || n.showNewButton ? (P(), w("div", {
							key: 1,
							class: j(n.newButtonClass)
						}, [R(i.$slots, "new-button", {}, () => [n.showNewButton ? (P(), S(H(t), {
							key: 0,
							to: n.newRoute,
							block: "",
							"data-qa-new-button": "",
							class: "layout-btn",
							color: "primary",
							onClick: c[1] ||= (e) => l("new-btn:clicked")
						}, {
							default: G(() => [O(H(s), {
								class: "mr-2",
								name: "add"
							}), D(" " + V(n.newButtonLabel), 1)]),
							_: 1
						}, 8, ["to"])) : C("", !0)], !0)], 2)) : C("", !0)]),
						T("div", Se, [
							i.$slots["secondary-filters"] ? (P(), w("div", Ce)) : C("", !0),
							i.$slots["secondary-filters"] ? R(i.$slots, "secondary-filters", {}, void 0, !0, 1) : C("", !0),
							i.$slots["extra-filters"] ? (P(), w("div", we, [O(H(t), {
								"data-qa-filter-button": "",
								class: j([{ "layout-btn-active": p.value }, "layout-btn px-1"]),
								"min-width": "55",
								outlined: "",
								onClick: c[2] ||= (e) => p.value = !p.value
							}, {
								default: G(() => [O(H(s), {
									color: "primary",
									name: "filter"
								}), n.selectedFilterCount > 0 ? (P(), S(H(e), {
									key: 0,
									"data-qa-filter-count": "",
									bordered: "",
									bottom: "",
									color: "black",
									"offset-x": "15",
									"offset-y": "20",
									overlap: ""
								}, {
									default: G(() => [D(V(n.selectedFilterCount), 1)]),
									_: 1
								})) : C("", !0)]),
								_: 1
							}, 8, ["class"])])) : C("", !0)
						]),
						T("div", Te, [i.$slots["third-filters"] ? (P(), w("div", Ee)) : C("", !0), i.$slots["third-filters"] ? (P(), w("div", De, [R(i.$slots, "third-filters", {}, void 0, !0)])) : C("", !0)])
					], !0)]),
					_: 3
				})),
				O(H(g), null, {
					default: G(() => [O(H(h), { class: "q-px-md" }, {
						default: G(() => [n.pagination?.loading ? (P(), S(H(f), {
							key: 0,
							indeterminate: ""
						})) : C("", !0), T("div", Oe, [T("div", ke, [T("div", Ae, [R(i.$slots, "table", {}, void 0, !0)])]), O(H(r), {
							modelValue: p.value,
							"onUpdate:modelValue": c[4] ||= (e) => p.value = e,
							side: "right",
							bordered: "",
							behavior: "desktop",
							"mini-to-overlay": ""
						}, {
							default: G(() => [T("div", je, [T("a", {
								"data-qa-remove-filters-button": "",
								class: "clear-filters-btn",
								onClick: c[3] ||= (e) => l("clear-filters")
							}, V(H(u)("listView.filterDelete")), 1)]), T("div", Me, [R(i.$slots, "extra-filters", {}, void 0, !0)])]),
							_: 3
						}, 8, ["modelValue"])])]),
						_: 3
					})]),
					_: 3
				}),
				_.value ? (P(), S(H(a), {
					key: 0,
					bordered: "",
					class: "bg-white flex justify-center q-pa-md"
				}, {
					default: G(() => [O(ye, { pagination: n.pagination }, null, 8, ["pagination"]), i.$slots.footer || n.multi ? (P(), w("div", Ne, [R(i.$slots, "footer", {}, () => [O(H(t), {
						class: "mr-4",
						color: "primary",
						onClick: c[5] ||= (e) => l("save-multi-selection")
					}, {
						default: G(() => [O(H(s), {
							class: "mr-2",
							name: "send"
						}), D(" " + V(n.multiLabel), 1)]),
						_: 1
					}), O(H(t), {
						color: "secondary",
						outline: "",
						onClick: c[6] ||= (e) => l("close")
					}, {
						default: G(() => [D(V(H(u)("common.cancel")), 1)]),
						_: 1
					})], !0)])) : C("", !0)]),
					_: 3
				})) : C("", !0)
			]),
			_: 3
		}, 8, ["style"]));
	}
}), [["__scopeId", "data-v-e63fd62d"]]), Fe = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%3e%3csymbol%20id='javascript'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M14%201a1.01%201.01%200%200%201%20.25.031l.03.009c.03.009.061.02.091.031l.027.012a.914.914%200%200%201%20.195.112c.04.03.078.062.114.098l-.093-.082.011.009.082.073%206%206a1.006%201.006%200%200%201%20.21.309l.012.027c.012.03.022.06.031.091l.008.03A.921.921%200%200%201%2021%208l-.008-.126.001.01L21%208v12a3%203%200%200%201-3%203H6a3%203%200%200%201-3-3V4a3%203%200%200%201%203-3h8zm-1%202H6a1%201%200%200%200-1%201v16a1%201%200%200%200%201%201h12a1%201%200%200%200%201-1V9h-5a1%201%200%200%201-.993-.883L13%208V3zm-2.155%207.2v6.744c0%201.504-.675%202.256-2.026%202.256-.299%200-.525-.009-.679-.026v-1.282c.103.009.265.013.487.013.257%200%20.455-.062.596-.186.141-.124.212-.348.212-.673V10.2h1.41zm3.135-.112c.67%200%201.177.19%201.521.572.344.381.515.928.515%201.64v.277H14.71v-.365c0-.301-.059-.521-.176-.66-.117-.138-.289-.207-.515-.207-.227%200-.398.07-.516.207-.117.139-.176.359-.176.66%200%20.369.099.692.296.968.197.277.492.591.886.943.327.302.59.568.792.798.201.23.373.51.515.836.143.327.214.7.214%201.119%200%20.712-.176%201.259-.528%201.64-.352.381-.863.572-1.534.572-.67%200-1.181-.19-1.533-.572-.352-.381-.528-.928-.528-1.64v-.54h1.307v.628c0%20.57.24.854.717.854s.716-.284.716-.854c0-.369-.098-.692-.295-.968-.197-.277-.492-.591-.886-.943-.327-.302-.591-.568-.792-.798a3.212%203.212%200%200%201-.516-.836%202.775%202.775%200%200%201-.213-1.119c0-.712.171-1.259.515-1.64s.85-.572%201.521-.572zM15%204.415V7h2.585L15%204.415z'/%3e%3c/symbol%3e%3csymbol%20id='gallery'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M2%207a1%201%200%200%201%20.993.883L3%208v12a1%201%200%200%200%20.883.993L4%2021h12a1%201%200%200%201%20.117%201.993L16%2023H4a3%203%200%200%201-2.995-2.824L1%2020V8a1%201%200%200%201%201-1zm18-6a3%203%200%200%201%203%203v12a3%203%200%200%201-3%203H8a3.05%203.05%200%200%201-.14-.003%201.005%201.005%200%200%201-.375-.04A3.002%203.002%200%200%201%205%2016V4a3%203%200%200%201%203-3zm-2.445%208.636L10.191%2017H20a1%201%200%200%200%20.993-.883L21%2016v-2.919l-3.445-3.445zM20%203H8a1%201%200%200%200-1%201v12a1%201%200%200%200%20.498.865l9.35-9.35a1%201%200%200%201%201.32-.083l.095.083L21%2010.252V4a1%201%200%200%200-.883-.993L20%203zm-9.111%201.556a2.333%202.333%200%201%201%200%204.666%202.333%202.333%200%200%201%200-4.666zm0%202a.333.333%200%201%200%200%20.666.333.333%200%200%200%200-.666z'%20/%3e%3c/symbol%3e%3csymbol%20id='video-performance'%20viewBox='0%200%2024%2024'%20stroke='currentColor'%20fill='none'%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M1%204v6h6M23%2020v-6h-6'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M23%2014l-4.64%204.36c-1.075%201.075-2.405%201.86-3.865%202.283-1.46.423-3.004.468-4.487.133-1.483-.336-2.856-1.041-3.993-2.051C4.88%2017.715%204.017%2016.433%203.51%2015M2%208.998l4.64-4.36c1.075-1.076%202.405-1.861%203.865-2.284%201.46-.422%203.004-.468%204.487-.132%201.483.335%202.856%201.041%203.993%202.051%201.136%201.01%201.998%202.291%202.505%203.725'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M11%209l4.5%203-4.5%203V9z'/%3e%3c/symbol%3e%3csymbol%20id='flag-de'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H24V24H0V0Z'%20fill='black'/%3e%3cpath%20d='M0%208H24V24H0V8Z'%20fill='%23DD0000'/%3e%3cpath%20d='M0%2016H24V24H0V16Z'%20fill='%23FFCE00'/%3e%3c/symbol%3e%3csymbol%20id='flag-en'%20viewBox='0%200%2024%2024'%3e%3cg%20clip-path='url(%23clip_a)'%3e%3cg%20clip-path='url(%23clip_b)'%3e%3cpath%20d='M-12%200V24H36V0H-12Z'%20fill='%23012169'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='white'%20stroke-width='6'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='%23C8102E'%20stroke-width='4'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='white'%20stroke-width='10'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='%23C8102E'%20stroke-width='6'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip_a'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip_b'%3e%3crect%20width='48'%20height='24'%20fill='white'%20transform='translate(-12)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/symbol%3e%3csymbol%20id='flag-it'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H8V24H0V0Z'%20fill='%23008C45'/%3e%3cpath%20d='M8%200H16V24H8V0Z'%20fill='white'/%3e%3cpath%20d='M16%200H24V24H16V0Z'%20fill='%23CD212A'/%3e%3c/symbol%3e%3c/svg%3e", Ie = /* @__PURE__ */ k({
	__name: "permission-info",
	props: { group: { default: "NewUser" } },
	setup(e) {
		let { t } = K(), r = e, i = {
			NewUser: "eye",
			Superadmin: "",
			Admin: "",
			Manager: "",
			PartnerManager: "",
			PartnerManagerPlus: "",
			ContentCreator: "",
			External: "",
			Assistant: ""
		}, a = {
			NewUser: "navigation.permissions.viewOnly",
			Superadmin: "",
			Admin: "",
			Manager: "",
			PartnerManager: "",
			PartnerManagerPlus: "",
			ContentCreator: "",
			External: "",
			Assistant: ""
		}, o = x(() => i[r.group]), s = x(() => a[r.group]);
		return (e, r) => (P(), S(H(n), {
			class: "q-pa-md",
			square: "",
			color: "blue",
			"text-color": "white",
			icon: o.value,
			label: H(t)(`${s.value}.label`)
		}, {
			default: G(() => [O(H(v), {
				class: "bg-grey-10 text-white shadow-4",
				anchor: "top middle",
				self: "bottom middle"
			}, {
				default: G(() => [D(V(H(t)(`${s.value}.hover`)), 1)]),
				_: 1
			})]),
			_: 1
		}, 8, ["icon", "label"]));
	}
}), Le = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2023.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20width='112'%20height='27'%20viewBox='0%200%20112%2027'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%200H12.1764L17.2308%2011.1677L22.2851%200H34.4615L22.4%2026.6553H12.0615L0%200Z'%20fill='white'/%3e%3cpath%20d='M36.759%200H48.2921V26.6553H36.759V0Z'%20fill='white'/%3e%3cpath%20d='M74.2538%2012.4319V12.36C76.0151%2011.9539%2077.3363%2011.2621%2078.2174%2010.2819C79.0976%209.30265%2079.5386%208.06094%2079.5386%206.55606V6.5201C79.5386%204.96758%2079.151%203.72005%2078.3783%202.77583C77.6047%201.83245%2076.4319%201.1339%2074.8607%200.68017C73.2902%200.22728%2071.3255%200%2068.9691%200H51.5436V26.6553H68.9332C71.5273%2026.6553%2073.6945%2026.3746%2075.4325%2025.8139C77.1696%2025.2532%2078.4916%2024.3984%2079.396%2023.2519C80.3005%2022.1055%2080.7531%2020.685%2080.7531%2018.9879V18.9161C80.7531%2017.1246%2080.1938%2015.6915%2079.0743%2014.617C77.9548%2013.5424%2076.3477%2012.8138%2074.2538%2012.4311V12.4319ZM62.6849%206.77079H66.8269C67.6363%206.77079%2068.2314%206.92619%2068.6123%207.23703C68.9932%207.54788%2069.1833%208.01331%2069.1833%208.63414V8.6701C69.1833%209.36279%2068.9808%209.85827%2068.5765%2010.1566C68.1714%2010.4557%2067.5412%2010.6045%2066.6843%2010.6045H62.6849V6.77079ZM68.8441%2019.3823C68.4031%2019.7166%2067.7071%2019.8837%2066.7551%2019.8837H62.6841V15.6564H66.6476C67.6479%2015.6564%2068.3731%2015.8235%2068.8257%2016.1578C69.2775%2016.4929%2069.5042%2017.0176%2069.5042%2017.7337C69.5042%2018.4983%2069.2833%2019.0473%2068.8432%2019.3815L68.8441%2019.3823Z'%20fill='white'/%3e%3cpath%20d='M83.1333%200H110.128V6.76723H94.6664V10.5989H107.256V15.6543H94.6664V19.8766H110.128V26.6553H83.1333V0Z'%20fill='white'/%3e%3c/svg%3e", Re = { class: "logo-style" }, ze = ["src"], Be = ["src"], Ve = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "logo-navigation",
	setup(e) {
		let t = Y();
		return (e, n) => (P(), w("div", Re, [H(t).sidebarNavigationOpen ? (P(), w("img", {
			key: 0,
			src: H(Le),
			height: "27",
			width: "112"
		}, null, 8, ze)) : C("", !0), H(t).sidebarNavigationOpen ? C("", !0) : (P(), w("img", {
			key: 1,
			src: H(Le),
			height: "9",
			width: "37"
		}, null, 8, Be))]));
	}
}), [["__scopeId", "data-v-cb752931"]]), He = [
	{
		icon: "edit",
		key: "navigation.articles",
		url: "/articles",
		right: "articles:navigate",
		testSelector: "articles"
	},
	{
		icon: "outbound",
		key: "navigation.externalContent._title",
		testSelector: "externalContent",
		right: "articles:navigate",
		children: [
			{
				icon: "share-2",
				key: "navigation.externalContent.partnerContent",
				url: "/assembler/partner",
				right: "assemblers:navigate",
				testSelector: "partnerContent"
			},
			{
				icon: "corporate_fare",
				key: "navigation.externalContent.agencyContent",
				url: "/assembler/agency",
				right: "assemblers:navigate",
				testSelector: "agencyContent"
			},
			{
				icon: "shield",
				key: "navigation.externalContent.expertsContent",
				url: "/experts-cockpit",
				right: "experts-cockpits:navigate",
				testSelector: "expertsContent"
			}
		]
	},
	{
		icon: "image",
		key: "navigation.images",
		url: "/images",
		right: "images:navigate",
		testSelector: "images"
	},
	{
		icon: "gallery",
		key: "navigation.galleries",
		url: "/galleries",
		right: "galleries:navigate",
		testSelector: "galleries"
	},
	{
		icon: "video",
		key: "navigation.videos",
		url: "/videos",
		right: "videos:navigate",
		testSelector: "videos"
	},
	{
		icon: "video-page",
		key: "navigation.videoPage",
		url: "/video-page",
		right: "video-pages:navigate",
		testSelector: "videoPages"
	},
	{
		icon: "file-text",
		key: "navigation.staticPages",
		url: "/static-page",
		right: "static-pages:navigate",
		testSelector: "staticPages"
	},
	{
		icon: "tag",
		key: "navigation.tags",
		url: "/tags",
		right: "tags:navigate",
		testSelector: "tags"
	},
	{
		icon: "hub",
		key: "navigation.hubPages",
		testSelector: "hubPages",
		right: "hub-pages:navigate",
		children: [{
			icon: "hub",
			key: "navigation.hubPages",
			url: "/hub-pages",
			right: "hub-pages:navigate",
			testSelector: "hubPagesList"
		}, {
			icon: "local_offer",
			key: "navigation.tagEntities",
			url: "/tag-entities",
			right: "tag-entities:read",
			testSelector: "tagEntities"
		}]
	},
	{
		icon: "local_movies",
		key: "navigation.movies",
		url: "/movies",
		right: "movies:navigate",
		testSelector: "movies"
	},
	{
		icon: "layers",
		key: "navigation.homeAndChannels",
		testSelector: "homeAndChannels",
		children: [
			{
				icon: "layers",
				key: "navigation.channels",
				url: "/channels",
				right: "channels:navigate",
				testSelector: "channels"
			},
			{
				icon: "list",
				key: "navigation.listArticles",
				url: "/article-list",
				right: "article-lists:navigate",
				testSelector: "listArticles"
			},
			{
				icon: "menu",
				key: "navigation.menuTree",
				url: "/menu-tree",
				right: "menu-tree:navigate",
				testSelector: "menuTree"
			},
			{
				icon: "link",
				key: "navigation.linkoutTeasers",
				url: "/linkout-teaser",
				right: "linkout-teasers:navigate",
				testSelector: "linkoutTeasers"
			}
		]
	},
	{
		icon: "cat-tool",
		key: "navigation.catTool",
		url: "/cat-tool",
		right: "cat-tool:navigate",
		testSelector: "catTool"
	},
	{
		icon: "science",
		key: "navigation.abHeadlineTest",
		url: "/ab-headline-test",
		right: "articles:navigate",
		testSelector: "abHeadlineTest"
	},
	{
		icon: "aissist",
		key: "navigation.aissist",
		url: "https://aissist.bv.burda.com/",
		isExternalUrl: !0,
		testSelector: "aissist"
	},
	{
		icon: "send",
		key: "navigation.articlePush",
		url: "/article-push",
		right: "article-pushes:navigate",
		testSelector: "articlePush"
	},
	{
		icon: "zap",
		key: "navigation.widgets._title",
		testSelector: "widgets",
		children: [
			{
				icon: "link",
				key: "navigation.articlesBox",
				url: "/articles-box",
				right: "articles-boxes:navigate",
				testSelector: "articlesBox"
			},
			{
				icon: "list",
				key: "navigation.linksBox",
				url: "/links-box",
				right: "links-boxes:navigate",
				testSelector: "linksBox"
			},
			{
				icon: "cta",
				key: "navigation.ctaButton",
				url: "/cta-button",
				right: "cta-buttons:navigate",
				testSelector: "ctaButton"
			},
			{
				icon: "list",
				key: "navigation.inpageWidget",
				url: "/inpage",
				right: "inpage-widgets:navigate",
				testSelector: "inpageWidget"
			},
			{
				icon: "type",
				key: "navigation.reusableText",
				url: "/reusable-text",
				right: "reusable-texts:navigate",
				testSelector: "reusableText"
			},
			{
				icon: "recipe",
				key: "navigation.recipe",
				url: "/recipe",
				right: "recipes:navigate",
				testSelector: "recipe"
			},
			{
				icon: "mail",
				key: "navigation.newsletterWidgets",
				url: "/newsletter",
				right: "newsletters:navigate",
				testSelector: "newsletterWidgets"
			},
			{
				icon: "insights",
				key: "navigation.finanzen100ChartWidgets",
				url: "/finanzen-100-chart-widget",
				right: "finanzen-100-chart-widgets:navigate",
				testSelector: "finanzen100ChartWidgets"
			}
		]
	},
	{
		icon: "user",
		key: "navigation.userManagement",
		testSelector: "userManagement",
		children: [
			{
				icon: "user",
				key: "navigation.users",
				url: "/users",
				right: "users:navigate",
				testSelector: "users"
			},
			{
				icon: "users",
				key: "navigation.authors",
				url: "/authors",
				right: "authors:navigate",
				testSelector: "authors"
			},
			{
				icon: "api",
				key: "navigation.apiUsers",
				url: "/api-user",
				right: "api-users:navigate",
				testSelector: "api-user"
			},
			{
				icon: "shield",
				key: "navigation.additiveRights",
				url: "/users/additive-rights",
				right: "users:navigate",
				testSelector: "additive-rights"
			}
		]
	},
	{
		icon: "tool",
		key: "navigation.tools",
		testSelector: "tools",
		children: [
			{
				icon: "database",
				key: "navigation.bfJobGroups",
				url: "/job-groups",
				right: "jobs:navigate",
				testSelector: "bfJobGroups"
			},
			{
				icon: "link-2",
				key: "navigation.seoWhiteList",
				url: "/seo-whitelist",
				right: "whitelists:navigate",
				testSelector: "seoWhiteList"
			},
			{
				icon: "sync",
				key: "navigation.moduleExamples.externalTool",
				url: "/external-tool",
				right: "external-tools:navigate",
				testSelector: "externalTool"
			},
			{
				icon: "signpost",
				key: "navigation.channelizer",
				url: "/channelizer",
				right: "channelizers:navigate",
				testSelector: "channelizer"
			},
			{
				icon: "redo",
				key: "navigation.redirect",
				url: "/redirect",
				right: "redirect-management:navigate",
				testSelector: "redirect"
			},
			{
				icon: "server",
				key: "navigation.apiTeaser",
				url: "/api-teaser",
				right: "api-teasers:navigate",
				testSelector: "apiTeaser"
			},
			{
				icon: "database",
				key: "navigation.authorMerge",
				url: "/author-merge",
				right: "authors:merge",
				testSelector: "authorMerge"
			},
			{
				icon: "biotech",
				key: "navigation.testreportGenerator",
				url: "/testreport-generator",
				right: "testreport-generator:navigate",
				testSelector: "testreportGenerator"
			}
		]
	},
	{
		icon: "group",
		key: "navigation.partnerManagement._title",
		testSelector: "partnerManagement",
		right: "partners:manage",
		children: [
			{
				icon: "category",
				key: "navigation.assemblerCategories",
				url: "/assembler-categories",
				right: "partners:manage",
				testSelector: "assemblerCategories"
			},
			{
				icon: "rss",
				key: "navigation.assemblerFeeds",
				url: "/assembler-feeds",
				right: "partners:manage",
				testSelector: "assemblerFeeds"
			},
			{
				icon: "users",
				key: "navigation.partners",
				url: "/partners",
				right: "partners:manage",
				testSelector: "partners"
			}
		]
	}
], Ue = /* @__PURE__ */ k({
	__name: "sidebar-nav-item",
	props: {
		item: {},
		isSidebarOpen: { type: Boolean },
		hasIcon: { type: Boolean }
	},
	setup(e) {
		let t = e, n = J(), { t: r } = K(), a = I(!1), o = x(() => !!t.item.children?.length), d = x(() => t.isSidebarOpen), f = x(() => {
			if (!(!t.item.url || t.item.isExternalUrl)) return {
				path: t.item.url,
				query: t.item.urlQuery
			};
		}), h = x(() => t.item.isExternalUrl ? t.item.url : void 0), g = x(() => {
			if (!t.item.url || t.item.isExternalUrl) return !1;
			let e = n.currentRoute.value;
			return e.path === t.item.url || !!e.matched.find((e) => e.path === t.item.url);
		}), _ = y((e) => {
			t.isSidebarOpen || (a.value = e);
		}, 200);
		return (t, n) => {
			let y = z("sidebar-nav-item", !0);
			return o.value ? (P(), w(b, { key: 1 }, [d.value ? (P(), S(H(i), {
				key: 0,
				label: H(r)(e.item.key),
				icon: e.item.icon,
				"expand-icon": "keyboard_arrow_down",
				"expand-icon-class": "sidebar__icon",
				"header-class": "sidebar__link",
				class: j({ "sidebar__link--active": a.value }),
				dense: "",
				"default-opened": !1,
				"data-qa-sidemenu": e.item.testSelector
			}, {
				default: G(() => [(P(!0), w(b, null, L(e.item.children, (e) => (P(), S(y, {
					key: e.key,
					item: e,
					"is-sidebar-open": d.value,
					"has-icon": !0,
					class: "sidebar__item-expandable"
				}, null, 8, ["item", "is-sidebar-open"]))), 128))]),
				_: 1
			}, 8, [
				"label",
				"icon",
				"class",
				"data-qa-sidemenu"
			])) : (P(), S(H(c), {
				key: 1,
				class: "sidebar__link sidebar__item sidebar__item-expandable--shortened",
				link: "",
				onMouseover: n[3] ||= (e) => H(_)(!0),
				onMouseout: n[4] ||= (e) => H(_)(!1)
			}, {
				default: G(() => [
					O(H(u), { avatar: "" }, {
						default: G(() => [O(H(s), {
							class: "sidebar__icon",
							name: e.item.icon
						}, null, 8, ["name"]), O(H(v), {
							class: "sidebar__tooltip",
							anchor: "top right",
							self: "top left",
							offset: [0, 15]
						}, {
							default: G(() => [D(V(H(r)(e.item.key)), 1)]),
							_: 1
						})]),
						_: 1
					}),
					O(H(u), null, {
						default: G(() => [O(H(l), null, {
							default: G(() => [D(V(H(r)(e.item.key)), 1)]),
							_: 1
						})]),
						_: 1
					}),
					O(H(m), {
						modelValue: a.value,
						"onUpdate:modelValue": n[0] ||= (e) => a.value = e,
						anchor: "top left",
						self: "top right",
						offset: [10, 0],
						"transition-show": "fade",
						"transition-hide": "fade",
						class: "sidebar__item-expandable--shortened",
						"active-class": "sidebar__link--active",
						square: "",
						onMouseover: n[1] ||= (e) => H(_)(!0),
						onMouseout: n[2] ||= (e) => H(_)(!1)
					}, {
						default: G(() => [O(H(p), { dense: "" }, {
							default: G(() => [(P(!0), w(b, null, L(e.item.children, (e) => (P(), S(y, {
								key: e.key,
								item: e,
								"is-sidebar-open": !0,
								"has-icon": !1
							}, null, 8, ["item"]))), 128))]),
							_: 1
						})]),
						_: 1
					}, 8, ["modelValue"])
				]),
				_: 1
			}))], 64)) : (P(), S(H(c), {
				key: 0,
				to: f.value,
				href: h.value,
				target: e.item.isExternalUrl ? "_blank" : void 0,
				class: "sidebar__link",
				"active-class": "sidebar__link--active",
				active: g.value,
				link: "",
				"data-qa-sidemenu": e.item.testSelector
			}, {
				default: G(() => [e.hasIcon ? (P(), S(H(u), {
					key: 0,
					avatar: ""
				}, {
					default: G(() => [O(H(s), {
						class: "sidebar__icon",
						name: e.item.icon
					}, null, 8, ["name"]), d.value ? C("", !0) : (P(), S(H(v), {
						key: 0,
						class: "sidebar__tooltip",
						anchor: "top right",
						self: "top left",
						offset: [0, 15]
					}, {
						default: G(() => [D(V(H(r)(e.item.key)), 1)]),
						_: 1
					}))]),
					_: 1
				})) : C("", !0), O(H(u), null, {
					default: G(() => [O(H(l), null, {
						default: G(() => [D(V(H(r)(e.item.key)), 1)]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"to",
				"href",
				"target",
				"active",
				"data-qa-sidemenu"
			]));
		};
	}
}), We = { class: "badge-container" }, Ge = { class: "sidebar__scroll" }, Ke = { class: "sidebar__item-divided" }, qe = {
	key: 2,
	class: "q-ml-sm"
}, Je = {
	key: 0,
	class: "q-ml-sm"
}, Ye = { class: "sidebar__bottom d-flex flex-center" }, Xe = ["textContent"], Ze = "https://burdaforward.atlassian.net/servicedesk/customer/portal/29/group/104", Qe = /* @__PURE__ */ k({
	__name: "sidebar-navigation",
	setup(n) {
		let r = Y(), i = ie(), a = J(), { t: o } = K(), d = U(), f = GLOBAL_CONFIG.APP_ENV, h = async () => {
			try {
				await i.logoutCurrentUser();
			} catch (e) {
				console.error(e);
			}
		}, g = I(He), _ = I("");
		N(() => {
			_.value = GLOBAL_CONFIG.VERSION;
		});
		let E = x(() => {
			let e = (e) => e.filter((e) => !e.right || i.hasRight(e.right)), t = e(g.value);
			return t.forEach((t) => {
				t.children &&= e(t.children);
			}), t;
		}), k = x(() => `padding-top: ${r.sidebarNavigationOpen ? 16 : 20}px`), A = x(() => `chevron_${r.sidebarNavigationOpen ? "left" : "right"}`), F = () => {
			i.authorUuid && a.push(`/authors/${i.authorUuid}`);
		}, z = {
			local: "ctf-primary",
			staging: "ctf-orange",
			production: "ctf-red",
			development: "ctf-blue",
			sandbox: "ctf-outline-blue"
		}, B = x(() => z[f] ?? ""), W = (e) => e.charAt(0).toUpperCase() + e.slice(1), q = x(() => {
			let e = W(f);
			return f === "local" ? e : f === "development" ? r.sidebarNavigationOpen ? e : e.slice(0, 3) : r.sidebarNavigationOpen ? e : e.slice(0, 4);
		}), te = {
			en: ["English", "flag-en"],
			de: ["Deutsch", "flag-de"]
		}, ne = ee(), ae = (e) => {
			switch (e) {
				case "de":
				case "en":
					r.setLanguage(e), ne.lang.set(re[e]);
					break;
				default: break;
			}
		}, X = I(!1), Z = y((e) => {
			X.value = e;
		}, 200), oe = [
			{
				value: "system",
				label: "common.themeSystem",
				icon: "brightness_auto"
			},
			{
				value: "light",
				label: "common.themeLight",
				icon: "light_mode"
			},
			{
				value: "dark",
				label: "common.themeDark",
				icon: "dark_mode"
			}
		], Q = I(!1), $ = y((e) => {
			Q.value = e;
		}, 200);
		return (n, a) => (P(), w("div", {
			style: M(k.value),
			class: "sidebar"
		}, [
			O(Ve),
			T("div", We, [O(H(e), {
				class: "badge-env",
				outline: H(f) === "sandbox",
				color: B.value,
				label: q.value
			}, null, 8, [
				"outline",
				"color",
				"label"
			])]),
			H(i).group === "NewUser" && H(r).sidebarNavigationOpen ? (P(), S(Ie, {
				key: 0,
				class: "sidebar__permission-info q-mb-sm",
				group: H(i).group
			}, null, 8, ["group"])) : C("", !0),
			T("div", Ge, [
				O(H(p), { dense: "" }, {
					default: G(() => [(P(!0), w(b, null, L(E.value, (e) => (P(), S(Ue, {
						key: e.key,
						item: e,
						"is-sidebar-open": H(r).sidebarNavigationOpen,
						"has-icon": !0
					}, null, 8, ["item", "is-sidebar-open"]))), 128))]),
					_: 1
				}),
				T("div", Ke, [O(H(t), {
					flat: "",
					dense: "",
					class: j(["user", { "user--collapsed": !H(r).sidebarNavigationOpen }])
				}, {
					default: G(() => [
						H(d).authorAvatar ? R(n.$slots, "author-avatar", {}, void 0, void 0, 0) : (P(), S(H(s), {
							key: 1,
							name: "user-profile",
							size: "16px"
						})),
						H(r).sidebarNavigationOpen ? (P(), w("span", qe, V(H(o)("navigation.profile")), 1)) : C("", !0),
						O(H(m), { class: "user-menu" }, {
							default: G(() => [O(H(p), null, {
								default: G(() => [
									O(H(c), {
										"close-popup": "",
										class: j(["user-menu__item", { "user-menu__item--active": X.value }]),
										clickable: "",
										onMouseenter: a[3] ||= (e) => H(Z)(!0),
										onMouseleave: a[4] ||= (e) => H(Z)(!1)
									}, {
										default: G(() => [O(H(u), null, {
											default: G(() => [O(H(l), null, {
												default: G(() => [D(V(H(o)("common.language")), 1)]),
												_: 1
											}), O(H(m), {
												modelValue: X.value,
												"onUpdate:modelValue": a[0] ||= (e) => X.value = e,
												anchor: "top end",
												self: "top start",
												offset: [26, 16],
												"transition-show": "fade",
												"transition-hide": "fade",
												onMouseenter: a[1] ||= (e) => H(Z)(!0),
												onMouseleave: a[2] ||= (e) => H(Z)(!1)
											}, {
												default: G(() => [O(H(p), { class: "user-menu" }, {
													default: G(() => [(P(), w(b, null, L(te, (e, t) => O(H(c), {
														key: t,
														clickable: "",
														ripple: "",
														class: "user-menu__item",
														onClick: (e) => ae(t)
													}, {
														default: G(() => [O(H(u), {
															avatar: "",
															class: "language-icon"
														}, {
															default: G(() => [O(H(s), {
																"custom-icon": !0,
																name: e[1],
																src: H(Fe)
															}, null, 8, ["name", "src"])]),
															_: 2
														}, 1024), O(H(u), null, {
															default: G(() => [D(V(e[0]), 1)]),
															_: 2
														}, 1024)]),
														_: 2
													}, 1032, ["onClick"])), 64))]),
													_: 1
												})]),
												_: 1
											}, 8, ["modelValue"])]),
											_: 1
										})]),
										_: 1
									}, 8, ["class"]),
									O(H(c), {
										class: j(["user-menu__item", { "user-menu__item--active": Q.value }]),
										clickable: "",
										onMouseenter: a[8] ||= (e) => H($)(!0),
										onMouseleave: a[9] ||= (e) => H($)(!1)
									}, {
										default: G(() => [O(H(u), null, {
											default: G(() => [O(H(l), null, {
												default: G(() => [D(V(H(o)("common.appearance")), 1)]),
												_: 1
											}), O(H(m), {
												modelValue: Q.value,
												"onUpdate:modelValue": a[5] ||= (e) => Q.value = e,
												anchor: "top end",
												self: "top start",
												offset: [26, 16],
												"transition-show": "fade",
												"transition-hide": "fade",
												onMouseenter: a[6] ||= (e) => H($)(!0),
												onMouseleave: a[7] ||= (e) => H($)(!1)
											}, {
												default: G(() => [O(H(p), { class: "user-menu" }, {
													default: G(() => [(P(), w(b, null, L(oe, (t) => O(H(c), {
														key: t.value,
														"data-qa-appearance-option": t.value,
														clickable: "",
														ripple: "",
														class: j(["user-menu__item", { "user-menu__item--active": H(r).colorScheme === t.value }]),
														onClick: (e) => H(r).setColorScheme(t.value)
													}, {
														default: G(() => [
															O(H(u), {
																avatar: "",
																class: "language-icon"
															}, {
																default: G(() => [O(H(s), { name: t.icon }, null, 8, ["name"])]),
																_: 2
															}, 1024),
															O(H(u), null, {
																default: G(() => [D(V(H(o)(t.label)), 1)]),
																_: 2
															}, 1024),
															t.value === "dark" ? (P(), S(H(u), {
																key: 0,
																side: ""
															}, {
																default: G(() => [O(H(e), {
																	class: "badge-beta",
																	outline: "",
																	label: H(o)("common.beta"),
																	"aria-label": H(o)("common.themeDarkBetaHint")
																}, {
																	default: G(() => [O(H(v), null, {
																		default: G(() => [D(V(H(o)("common.themeDarkBetaHint")), 1)]),
																		_: 1
																	})]),
																	_: 1
																}, 8, ["label", "aria-label"])]),
																_: 1
															})) : C("", !0)
														]),
														_: 2
													}, 1032, [
														"data-qa-appearance-option",
														"class",
														"onClick"
													])), 64))]),
													_: 1
												})]),
												_: 1
											}, 8, ["modelValue"])]),
											_: 1
										})]),
										_: 1
									}, 8, ["class"]),
									O(H(c), {
										"close-popup": "",
										clickable: "",
										disable: H(i).authorUuid === void 0,
										class: "user-menu__item",
										onClick: F
									}, {
										default: G(() => [O(H(u), null, {
											default: G(() => [O(H(l), null, {
												default: G(() => [D(V(H(o)("navigation.authorProfile")), 1)]),
												_: 1
											})]),
											_: 1
										})]),
										_: 1
									}, 8, ["disable"]),
									O(H(c), {
										"close-popup": "",
										clickable: "",
										class: "user-menu__item",
										onClick: h
									}, {
										default: G(() => [O(H(u), null, {
											default: G(() => [O(H(l), null, {
												default: G(() => [D(V(H(o)("navigation.logout")), 1)]),
												_: 1
											})]),
											_: 1
										})]),
										_: 1
									})
								]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 3
				}, 8, ["class"])]),
				T("div", null, [O(H(t), {
					flat: "",
					dense: "",
					class: j(["user", { "user--collapsed": !H(r).sidebarNavigationOpen }]),
					href: Ze,
					target: "_blank"
				}, {
					default: G(() => [O(H(s), {
						name: "report-problem",
						size: "16px"
					}), H(r).sidebarNavigationOpen ? (P(), w("span", Je, V(H(o)("navigation.reportProblem")), 1)) : C("", !0)]),
					_: 1
				}, 8, ["class"])]),
				T("div", Ye, [H(r).sidebarNavigationOpen ? (P(), w("span", {
					key: 0,
					class: "col q-pl-md",
					textContent: V(`Version: ${_.value}`)
				}, null, 8, Xe)) : C("", !0), O(H(t), {
					flat: "",
					icon: A.value,
					title: H(o)("navigation.minimize"),
					onClick: a[10] ||= (e) => H(r).toggleSidebarNavigation()
				}, null, 8, ["icon", "title"])])
			])
		], 4));
	}
}), $e = /* @__PURE__ */ $(/* @__PURE__ */ k({
	__name: "main-layout",
	setup(e) {
		let t = I(), n = Y();
		return (e, i) => (P(), S(H(d), { view: "lhr Lpr LFF" }, {
			default: G(() => [O(H(r), {
				id: "mainNavigationSidebar",
				ref_key: "drawer",
				ref: t,
				"model-value": !0,
				mini: !H(n).sidebarNavigationOpen,
				side: "left",
				width: H(ne),
				behavior: "desktop"
			}, {
				default: G(() => [O(Qe)]),
				_: 1
			}, 8, ["mini", "width"]), O(H(q))]),
			_: 1
		}));
	}
}), [["__scopeId", "data-v-2cafb8ed"]]);
//#endregion
export { oe as BLOCK_DRAWER_CONFIG, X as BLOCK_DRAWER_MINI_WIDTH, Z as BLOCK_DRAWER_WIDTH, _e as EditViewLayout, ae as HEADER_HEIGHT_HINT, Pe as ListViewLayout, $e as MainLayout, ce as StatusIcon };

//# sourceMappingURL=index.es.js.map